import { ApiResponse } from './../../models/ApiResponse';
import { BookingDeceasedProfiles } from './../../models/BookingDeceasedProfiles';
import { API_URL, DATE_FORMAT } from "./../../app.constant";
import { Booking } from "./../../models/booking";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BookingView } from "src/app/dashboard/dashboard.component";
import { BookingCalendarDateStatus } from "src/app/book-appointment/book-appointment.component";
import { DatePipe } from '@angular/common';
import { BookingHistoryView } from 'src/app/book-history/book-history.component';
import { BookingHistory } from 'src/app/models/BookingHistory';
import { BasicAuthenticationService } from 'src/app/auth/basic-authentication.service';

const CMS_GetBookingView = "CMS_GetBookingView";

const CMS_GetBookingHistoryView = "CMS_GetBookingHistoryView";

const ROWLIMIT = "1000";

const COM_CANCELBOOKING = "COM_CancelBooking";

const COM_GetBookingCalendarDateStatus = "COM_GetBookingCalendarDateStatus";

const COM_GetAvailableTimeSlot = "COM_GetAvailableTimeSlot";

const CMS_CreateBooking: string = "CMS_CreateBooking";

@Injectable({
  providedIn: "root"
})
export class BookingDataService {
  constructor(private httpClient: HttpClient, private datePipe: DatePipe, 
    private basicAuthenticationService: BasicAuthenticationService) {}

  getBookingView(bookingTimeFrom: Date, bookingTimeTo: Date, mainAccountId: string, accountId: string, status: string) {
    let params = new HttpParams()
      .set("rowLimit", ROWLIMIT)
      .set("bookingTimeFrom", this.datePipe.transform(bookingTimeFrom,DATE_FORMAT))
      .set("bookingTimeTo", this.datePipe.transform(bookingTimeTo,DATE_FORMAT))
      .set("mainAccountId", mainAccountId)
      .set("accountId", accountId)
      .set("status", status);

    return this.httpClient.get<BookingView[]>(`${API_URL}/${CMS_GetBookingView}`, { params });
  }

  getBookingHistoryView(bookingTimeFrom: Date, bookingTimeTo: Date, mainAccountId: string, accountId: string, status: string) {
    let params = new HttpParams()
      .set("rowLimit", ROWLIMIT)
      .set("bookingTimeFrom", this.datePipe.transform(bookingTimeFrom,DATE_FORMAT))
      .set("bookingTimeTo", this.datePipe.transform(bookingTimeTo,DATE_FORMAT))
      .set("mainAccountId", mainAccountId)
      .set("accountId", accountId)
      .set("status", status);
      
    return this.httpClient.get<BookingHistory[]>(`${API_URL}/${CMS_GetBookingHistoryView}`, { params });
  }

  cancelBooking(booking: Booking) {

    booking.actionBy = this.basicAuthenticationService.getLoginAccountName();

    return this.httpClient.post<any>(`${API_URL}/${COM_CANCELBOOKING}`, booking);
  }

  getBookingCalendarDateStatus(accountId: string) {
    let params = new HttpParams().set("accountId", accountId);

    return this.httpClient.get<ApiResponse<BookingCalendarDateStatus>>(`${API_URL}/${COM_GetBookingCalendarDateStatus}`, { params });
  }

  createBooking(bookingDeceasedProfiles: BookingDeceasedProfiles) {

    bookingDeceasedProfiles.booking.actionBy = this.basicAuthenticationService.getLoginAccountName();

    return this.httpClient.post<any>(`${API_URL}/${CMS_CreateBooking}`, bookingDeceasedProfiles);
  }

  getAvailableTimeSlot(accountId: string, bookingDate: Date) {
    let params = new HttpParams().set("accountId", accountId).set("bookingDate", this.datePipe.transform(bookingDate, DATE_FORMAT));

    return this.httpClient.get<ApiResponse<Date[]>>(`${API_URL}/${COM_GetAvailableTimeSlot}`, { params });
  }
}
